import React, { Component, Fragment } from 'react'
import { addLocaleData, IntlProvider } from 'react-intl'
import { Switch, Route, Redirect} from 'react-router-dom'
import es from 'react-intl/locale-data/es'
import en from 'react-intl/locale-data/en'
import messages_en from './translations/en.json'
import messages_es from './translations/es.json'
import Menu from './components/Menu'
import Footer from './components/Footer'
import Embedded from './pages/Embedded'
import OnSelect from './pages/OnSelect'
import OnClick from './pages/OnClick'

const messages = {
  en: messages_en,
  es: messages_es,
}
addLocaleData([...en, ...es])
class App extends Component {
  state = {
    language: 'en',
  }
  handleSetLanguage = (language) => {
    const elBridge = document.querySelector('script[data-bridge][data-name="AmigoMiniGames"]')
    elBridge.setAttribute('data-lang', language)
    this.setState({
      language
    })
  }
  render() {
    const {language} = this.state
    return (
      <IntlProvider
        locale={language}
        key={language}
        messages={messages[language]}>
        <Fragment>
          <Menu handleSetLanguage={this.handleSetLanguage} language={language} />
          <Switch>
            <Route path="/" exact component={Embedded} />
            <Route path="/on-select" exact component={OnSelect} />
            <Route path="/on-click" exact component={OnClick} />
            <Route render={() => <Redirect to="/"/>} />
          </Switch>
          <Footer />
        </Fragment>
      </IntlProvider>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js